module.exports = __webpack_public_path__ + "img/Familiengrinsen.cb6b1fb9.jpg";